import isArrayLikeObject from './isArrayLikeObject';

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

export default castArrayLikeObject;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/_castArrayLikeObject.js
// module id = 146
// module chunks = 0